/**
 * Values typed by the user next to predefined options ("+ own value") are stored with this prefix,
 * so they can be told apart from option values in the payload.
 */
export const CUSTOM_OPTION_PREFIX = 'custom:';

export const toCustomOptionValue = (text: string): string => `${CUSTOM_OPTION_PREFIX}${text}`;

export const isCustomOptionValue = (value: unknown): value is string =>
  typeof value === 'string' && value.startsWith(CUSTOM_OPTION_PREFIX);

export const getCustomOptionText = (value: string): string => value.slice(CUSTOM_OPTION_PREFIX.length);
